export default __webpack_public_path__ + "static/media/Phantom Ward.c1ab766a.jpg";